import React, { useCallback, useMemo } from 'react';
import NoLocationPointToast from '@shopDetails/components/NoLocationPointToast';
import FormatPrice from '@shared/containers/FormatPrice';
import { injectIntl as withIntl } from 'react-intl';
import getPriceTotal from '@productConfig/utils/getPriceTotal';
import getCrossSellingProductsTotal from '@productConfig/utils/getCrossSellingProductsTotal';

import PropTypes from 'prop-types';
import ButtonWithCounter from '../ButtonWithCounter/ButtonWithCounter';
import NoLocationPOintToastContainer from '../NoLocationPointToastContainer';
import FooterContainer from '../FooterContainer';

import messages from '../../messages';

function ProductConfigurationFooter({
  cartItemInEdition,
  crossSellingProducts,
  Footer,
  intl: { formatMessage },
  isLoading,
  isNotOrganicFlow,
  onGetPromiseLocation,
  onSubmit,
  product,
  quantity,
}) {
  const getCrossSellingItemsQuantity = useCallback(
    crossSellingProds =>
      crossSellingProds?.reduce((total, item) => total + item.quantity, 0),
    [],
  );

  const priceTotal = useMemo(() => {
    if (isLoading !== null && product && quantity) {
      return isLoading ? null : getPriceTotal(product, quantity);
    }
    return null;
  }, [isLoading, product, quantity]);

  const crossSellingTotal = useMemo(
    () =>
      isLoading
        ? null
        : getCrossSellingProductsTotal(crossSellingProducts || []),
    [isLoading, crossSellingProducts],
  );

  const crossSellingItemsQuantity = getCrossSellingItemsQuantity(
    crossSellingProducts,
  );

  const NormalFooter = () =>
    isNotOrganicFlow ? (
      <NoLocationPOintToastContainer>
        <NoLocationPointToast
          position="relative"
          open
          onClick={onGetPromiseLocation}
        />
      </NoLocationPOintToastContainer>
    ) : (
      <Footer
        elementId="product__add__action"
        label={
          <ButtonWithCounter
            itemsCount={quantity + crossSellingItemsQuantity}
            text={formatMessage(
              cartItemInEdition
                ? messages.button_action_modify
                : messages.button_action_add,
            )}
            subtotal={
              priceTotal && (
                <FormatPrice value={priceTotal + crossSellingTotal} />
              )
            }
          />
        }
        color="primary"
        onClick={onSubmit}
        disabled={isLoading}
        block
      />
    );

  return (
    <>
      <FooterContainer>
        <NormalFooter />
      </FooterContainer>
    </>
  );
}

ProductConfigurationFooter.propTypes = {
  product: PropTypes.shape({
    maxQuantity: PropTypes.number,
  }).isRequired,
  isNotOrganicFlow: PropTypes.bool.isRequired,
  onGetPromiseLocation: PropTypes.func.isRequired,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  cartItemInEdition: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  crossSellingProducts: PropTypes.array,
  Footer: PropTypes.elementType.isRequired,
  quantity: PropTypes.number,
};

export default withIntl(ProductConfigurationFooter);
